module.exports = __webpack_public_path__ + "img/brand-logo5.0ea01439.png";